import { render, staticRenderFns } from "./Editar-Evento.vue?vue&type=template&id=c364bb88&"
import script from "./Editar-Evento.vue?vue&type=script&lang=js&"
export * from "./Editar-Evento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Editar-Evento.vue"
export default component.exports